import { useEffect, useState } from "react";
import AntDInputField from "./AntDInputField";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useForm } from "antd/lib/form/Form";
import { Form } from "antd";
import UserProfileService from "services/UserProfileService";
import { updatePrfile } from "redux/userRedux";
import LoadingSpin from "components/Loading spins/LoadingSpin";

const onFinishFailed = (errorInfo: any) => {
  toast.error(errorInfo.errorFields[0].errors[0]);
};

function ChangeUserName() {
  const dispatch = useDispatch<any>();
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [form] = useForm<any>();
  const [loadingSpin, setLoadingSpin] = useState<boolean>(false);
  const [, setLoading] = useState<boolean>(false);

  const onFinish = async (value: any) => {
    setLoadingSpin(true);
    const finalObj: any = {
      ...value,
    };
    const formDataObj = new FormData();

    for (const key in finalObj) {
      formDataObj.append(key, finalObj[key]);
    }
    await UserProfileService.editUserName(formDataObj)
      .then((response: any) => {
        setLoadingSpin(false);
        if (response.status === 200) {
          toast.success("Username Updated");
          dispatch(updatePrfile(response.data.data));
        } else {
          toast.error("There is an issue when updating username");
        }
      })
      .catch((error) => {
        setLoadingSpin(false);
        if (error.response && error.response.status === 422) {
          const errorData = error.response.data.errors.new_username[0];
          setErrors(errorData);
          toast.warning(errorData);
        } else {
          toast.error("An error occurred. Please try again.");
        }
      });
  };

  const [errors, setErrors] = useState({
    username: [],
  });

  useEffect(() => {
    setLoading(true);
    const initialValue = {
      new_username: loggedInUser?.username,
    };
    form.setFieldsValue(initialValue);
    setLoading(false);
  }, [loggedInUser, form]);

  return (
    <div className="mb-6 w-full px-4 max-sm:px-3">
      <div className="mt-5 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* MAIN form (2/3) */}
        <div className="rounded-2xl p-6 lg:col-span-2 max-sm:p-4">
          <Form
            form={form}
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            autoComplete="on"
          >
            <h1 className="text-[25px] font-bold text-white max-sm:text-[22px]">
              Change Username
            </h1>
            <p className="mb-4 mt-1 text-sm text-white/50">
              Choose a new username. You'll need your password to confirm.
            </p>

            <div className="w-full">
              <span className="text-[15px] text-white">Username</span>
              <AntDInputField
                name="new_username"
                rules={[
                  {
                    required: true,
                    message: "Please enter your username!",
                  },
                ]}
              />
              {errors.username?.length > 0 && (
                <div className="mb-5 text-left text-red-400">
                  <span className="error">{errors.username[0]}</span>
                </div>
              )}
            </div>
            <div className="w-full">
              <span className="text-[15px] text-white">Password</span>
              <AntDInputField
                name="current_password"
                placeholder="Enter your password"
                type="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password!",
                  },
                ]}
              />
            </div>

            <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
              <button
                className="button-red mt-4 min-w-[130px] rounded-full px-4 py-2 text-white transition-opacity hover:opacity-90 max-sm:w-full"
                type="submit"
              >
                {loadingSpin ? (
                  <LoadingSpin fontSize={20} color={"white"} />
                ) : (
                  `Save Changes`
                )}
              </button>
            </Form.Item>
          </Form>
        </div>

        {/* SIDE info (1/3) */}
        <div className="space-y-6 lg:col-span-1">
          <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.15em] text-white/40">
              Current
            </p>
            <div className="flex items-center justify-between text-sm">
              <span className="text-white/50">Username</span>
              <span className="font-medium text-white">
                @{loggedInUser?.username}
              </span>
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.15em] text-white/40">
              Tips
            </p>
            <ul className="space-y-2 text-sm text-white/60">
              <li>Usernames must be unique.</li>
              <li>Use letters, numbers, and underscores.</li>
              <li>Your password is required to confirm the change.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangeUserName;